import { render, staticRenderFns } from "./CcicPhoto.vue?vue&type=template&id=15fe60fa"
import script from "./CcicPhoto.vue?vue&type=script&lang=js"
export * from "./CcicPhoto.vue?vue&type=script&lang=js"
import style0 from "./CcicPhoto.vue?vue&type=style&index=0&id=15fe60fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports